import { desktopCSS, mobileCSS, tabletCSS } from '@measures/responsive'
import { FunctionComponent, ReactNode, useEffect, useRef } from 'react'
import { useQueryClient } from 'react-query'
import styled, { css } from 'styled-components'
import { printCSS } from '@utils/style'

const StyledCommentingWrapper = styled.div`
  position: relative;

  ${desktopCSS(css`
    scroll-margin-top: 110px;
  `)}

  ${tabletCSS(css`
    scroll-margin-top: 110px;
  `)}

  ${mobileCSS(css`
    scroll-margin-top: 98px;
  `)}
  ${printCSS(css`
    display: none;
  `)}
`

const CommentingWrapper: FunctionComponent<{ children?: ReactNode }> = ({
  children,
}) => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const queryClient = useQueryClient()

  useEffect(() => {
    queryClient.setQueryData('commenting-widget-ref', wrapperRef)
    return () => {
      queryClient.removeQueries('commenting-widget-ref', { exact: true })
    }
  }, [queryClient, wrapperRef])

  return (
    <StyledCommentingWrapper ref={wrapperRef}>
      {children}
    </StyledCommentingWrapper>
  )
}

export default CommentingWrapper
